interface IProps {
  loadingConditions: boolean;
  viewRef: React.ForwardedRef<any>;
}

function ScrollLoading(props: IProps) {
  const { loadingConditions, viewRef } = props;
  return loadingConditions ? (
    <div className="scroll-loading" ref={viewRef}>
      Contents Loading ...
    </div>
  ) : (
    <div className="last-content">Last Contents</div>
  );
}

export default ScrollLoading;
